// extracted by mini-css-extract-plugin
export default {"icon":"Logo_icon__etpar","logo":"Logo_logo__czcji","text":"Logo_text__PyV8R","productName":"Logo_productName__wNnkI"};